export const removeOrAddCheckboxArrayEntry = <T>(array: T[], value: T, checked: boolean) => {
    const newArr = array.slice()

    if (checked) {
        newArr.push(value)
    } else {
        const index = newArr.indexOf(value)
        if (index !== -1) {
            // exists - remove
            newArr.splice(index, 1)
        }
    }

    return newArr
}
